import React from "react";
import { Form, Select } from "semantic-ui-react";

const SelectFieldType = ({
  selectedDataField,
  name = `has${selectedDataField}`,
  value,
  onChange,
  label = "Choose Field Type:",
  options,
}) => {
  return (
    <Form className="mt-1">
      <Form.Field inline>
        <label>{label}</label>
        <Select
          options={options}
          onChange={onChange}
          name={name}
          value={value}
        />
      </Form.Field>
    </Form>
  );
};

export default SelectFieldType;
